import MaskedInput from 'react-text-mask';
import styled from 'styled-components';

import { inputStyle } from '../input/styles';
import { IMaskInputProps } from './types';

export const InputMaskContent = styled(MaskedInput)<IMaskInputProps>`
  ${inputStyle}
`;
